import type { ComponentType, SVGProps } from "react";
import type { NavIconKey } from "@/config/nav-links";
import {
    ArrowLeftRight,
    Banknote,
    BookOpenText,
    CalendarDays,
    Calculator,
    ChartArea,
    ChartCandlestick,
    ChartLine,
    ChartNoAxesColumn,
    ChartSpline,
    Clapperboard,
    Cuboid,
    Coins,
    Globe,
    HandCoins,
    IndianRupee,
    Lightbulb,
    Newspaper,
    Shuffle,
    Fingerprint,
} from "lucide-react";
import CalendarGraph from "@/app/assets/icons/calendar-graph";

type NavIcon = ComponentType<SVGProps<SVGSVGElement> & { strokeWidth?: number | string }>;

export const navIcons: Record<NavIconKey, NavIcon> = {
    stocks: ChartLine,
    "global-stocks": Globe,
    "mutual-funds": HandCoins,
    ipos: CalendarGraph,
    etfs: ArrowLeftRight,
    "futures-options": Newspaper,
    "digital-gold": Coins,
    "digital-silver": Cuboid,
    "fixed-deposits": Banknote,
    bonds: Newspaper,
    "calendar-days": CalendarDays,
    calculator: Calculator,
    "chart-candlestick": ChartCandlestick,
    "chart-area": ChartArea,
    "chart-spline": ChartSpline,
    lightbulb: Lightbulb,
    clapperboard: Clapperboard,
    "book-open-text": BookOpenText,
    shuffle: Shuffle,
    "indian-rupee": IndianRupee,
    "chart-no-axes-column": ChartNoAxesColumn,
    fingerprint: Fingerprint,
};
